import {HelitecnicaLogo} from "@project/components/branding/helitecnica-logo";
import {Button, Card} from "@project/design-system-web";
import {createFileRoute} from "@tanstack/react-router";

import {startDefaultLogin} from "./-auth-status-actions";

export const Route = createFileRoute("/signed-out")({
  component: SignedOutPage,
});

export function SignedOutPage() {
  return (
    <main className="flex min-h-dvh items-center justify-center p-6">
      <Card className="w-full max-w-sm gap-4">
        <Card.Header className="items-center gap-3">
          <HelitecnicaLogo className="block h-16 w-56" />
          <Card.Title>Signed out</Card.Title>
          <Card.Description>Your ERP session has ended.</Card.Description>
        </Card.Header>
        <Card.Footer>
          <Button className="w-full" onPress={startDefaultLogin}>
            Sign in
          </Button>
        </Card.Footer>
      </Card>
    </main>
  );
}
